import React, { useState } from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import Button from "@material-ui/core/Button";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Navigation from "../../../common/Navigation";
import { API_CANDIDATE } from "../../../utils/config";
import Notifier from "../../aside/Notifier";
import {Link} from 'react-router-dom'

// upload resume component
const Uploadresume = () => {
  const [fileupload, setfileupload] = useState("");
  const [message, setMessage] = useState("");
  const [error, seterrors] = useState("");
  const [showFiles, setShowFiles] = useState("");
  const history = useHistory();

  // onchange for selecting a file
  const fileselecting = (e) => {
    setShowFiles(
      Array.from(e.target.files).map((file) => (
        <span key={file}>{file.name}</span>
      ))
    );
    seterrors('')
    setfileupload(e.target.files[0]);
  };

  // upload function triggers when submit upload button

  const uploadImage = async () => {
    console.log(!fileupload);
   

      if (fileupload) {
        if (fileupload.size <= 1024 * 1024 * 1) {
          const fileToUpload = fileupload;
          const data = new FormData();
          data.append("name", "Image Upload");
          data.append("file", fileToUpload);

          await axios
            .post(
              `${API_CANDIDATE}/v1/api/upload/upload-resume`,
              data,
              { withCredentials: true },
              {
                headers: {
                  "Content-Type": "multipart/form-data; ",
                },
              }
            )
            .then((res) => {
              if (res.data.ok) {
                setMessage(" Resume Uploaded Successfully");
                seterrors("");
                setTimeout(() => {
                  setMessage("");
                  seterrors("");
                  history.push({
                    pathname: "/dashboard",
                  });
                }, 2000);
              } else if (res.data.message === "Require atlease one file") {
                seterrors("Please Select File to upload");
              }
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data.message === "Invalid Extension type"
              ) {
                seterrors("please select correct format");
              }
            });
        } else {
          seterrors("File size must less than 1MB ");
        }
      } else {
        seterrors("Please Select File to upload");
      }
 
 

    

  }

  return (
    <div className="signupload-container">
      <Navigation show="true" />
      <div
        style={{ width: "1000px", display: "flex" }}
        className="childupload-signcontainer"
      >
        <div style={{ width: "50%" }}>
          <div className="childuploadfirst-container">
            <h1 style={{ color: "green", fontSize: "50px" }}>
              {" "}
              <AiOutlineCloudUpload />{" "}
            </h1>
            <h4>Upload Your Resume</h4>
          </div>

          <div className="childuploadsecond-container">
            <div
              style={{
                height: "100%",
                width: "100%",
                borderStyle: "dotted",
                borderRadius: "10px",
                flexDirection: "column",
                alignItems: "center",
                borderColor: "green",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <span style={{ fontSize: "30px", marginBottom: "10px" }}>
                Drag & Drop
              </span>
              <span style={{ fontSize: "20px", marginBottom: "10px" }}>
                Supported format files
              </span>
              <span style={{ marginBottom: "5px", fontSize: "14px" }}>
                (Pdf)
              </span>
              <span className="btn btn-primary btn-file">
                Browse...
                <input type="file" onChange={fileselecting} />
              </span>

              <span style={{ fontWeight: "bold" }}>{showFiles}</span>
            </div>

            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                marginTop: "30px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={uploadImage}
                style={{ background: "#005500" }}
              >
                {" "}
                Upload
              </Button>
              <span style={{ fontSize: 15, color: "red" }}>{error}</span>
            </div>

            {message && <Notifier message={message} />}
          </div>
        </div>
        <div
          style={{
            width: "20%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "2rem" }}>OR</span>
        </div>
        <div
          style={{
            width: "40%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{ background: "#005500", width: "50%",color:"white" }}
          >
             <Link to="/dashboard/my_profile" className="no-dec">
           <span style={{color:"white"}}>Create Resume</span>
          </Link>
          
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Uploadresume;
